<!-- 选择优惠券  输入兑换码 -->
<template>
    <div class="selectCoupon" :class="{'show': show}">
        <div class="cover" @click="show = false"></div>
        <div class="content">
            <!-- <div class="title">优惠券/兑换码</div> -->
            <div class="title">优惠券</div>
            <img class="close" @click="close" :src="require('@/common/images/course/close.png')" alt="">
            <div class="couponList">
                <van-checkbox-group v-model="selectIndex" v-if="list.length" @change="selectIndexChange">
                    <div class="item" v-for="(item, index) in list" :key="index" @click="changeSelectIndex(index)">
                        <div class="left"><van-checkbox :name="item.couponvoucherid"></van-checkbox></div>
                        <div class="right">
                            <div class="valueBox" v-if="item.voucherdistype === 1">
                                <div class="unit">￥</div>
                                <div class="value">{{item.faceprice}}</div>
                                <div class="preferContent">{{item.prefercontent}}</div>
                            </div>
                            <div class="valueBox" v-if="item.voucherdistype === 2">
                                <div class="value">{{item.voucherdisrate}}</div>
                                <div class="unit">折</div>
                                <div class="preferContent">{{item.prefercontent}}</div>
                            </div>
                            <div class="datetime">有效期：{{item.datetime}}</div>
                            <div class="tips" v-if="item.isexpire">快到期了</div>
                        </div>
                    </div>
                </van-checkbox-group>
                <div class="noData" v-else>
                    <img :src="require('@/common/images/mindex/noData.png')" alt="">
                    <p>当前暂无优惠券</p>
                </div>
            </div>
            <!-- <div class="codeBox">
                <div class="left">
                    <div class="name">兑换码</div>
                    <van-field v-model="code" placeholder="请输入兑换码" />
                </div>
                <div class="right">
                    <van-button>兑换</van-button>
                </div>
            </div> -->
            <div class="affirmBtn">
                <van-button @click="affirmUse">确定</van-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            selectIndex: [],
            list: [],
            code: ''
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        open(list, selectCoupon) {
            this.list = list
            if (selectCoupon !== -1 && list.length) {
                this.selectIndex = [list[selectCoupon].couponvoucherid]
            }
            this.show = true
        },
        changeSelectIndex(index) {
            if (this.selectIndex[0] !== this.list[index].couponvoucherid) {
                this.selectIndex = [this.list[index].couponvoucherid]
            } else {
                this.selectIndex = []
            }
        },
        close() {
            this.show = false
        },
        selectIndexChange(list) {
            if (list.length > 1) {
                this.selectIndex = [list[list.length-1]]
            }
        },
        affirmUse() {
            this.show = false
            this.$emit('affirmCoupon', this.selectIndex)
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .selectCoupon {
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.3);
        opacity: 0;
        transition: opacity 0.3s;
        transform: translate3d(0, 100%, 0);
        &.show {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
        .cover {
            height: 100%;
        }
        .content {
            height: 7.6rem;
            background: #fff;
            border-radius: 0.25rem 0.25rem 0 0;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 0.32rem;
            box-sizing: border-box;
            .title {
                text-align: center;
                font-size: 0.32rem;
                font-weight: bold;
                line-height: 0.32rem;
                padding: 0.32rem 0.32rem;
            }
            .close {
                width: 0.4rem;
                height: 0.4rem;
                position: absolute;
                top: 0.28rem;
                right: 0.24rem;
            }
            .couponList {
                height: 5.5rem;
                overflow-y: scroll;
                // padding-bottom: 0.1rem;
                .item {
                    margin-bottom: 0.2rem;
                    display: flex;
                    align-items: center;
                    .left {
                        margin-right: 0.2rem;
                    }
                    .right {
                        background: #FEF6EF;
                        padding: 0.28rem 0.24rem;
                        border-radius: 0.1rem;
                        flex: 1;
                        position: relative;
                        .valueBox {
                            display: flex;
                            // vertical-align: bottom;
                            align-items: baseline;
                            color: #FE666D;
                            .unit {
                                font-size: 0.3rem;
                                // line-height: 0.72rem;
                                // padding-top: 0.02rem;
                            }
                            .value {
                                font-size: 0.52rem;
                                // line-height: 0.72rem;
                            }
                            .preferContent {
                                font-size: 0.28rem;
                                margin-left: 0.15rem;
                                // line-height: 0.72rem;
                                // padding-top: 0.02rem;
                            }
                        }
                        .datetime {
                            font-size: 0.2rem;
                            color: #999999;
                            line-height: 0.28rem;
                            padding-top: 0.1rem;
                        }
                        .tips {
                            width: 1.28rem;
                            height: 0.36rem;
                            background: #FEE4E5;
                            font-size: 0.24rem;
                            color: #FE666D;
                            text-align: center;
                            position: absolute;
                            line-height: 0.36rem;
                            top: 0;
                            right: 0;
                            border-radius: 0 0.1rem 0 0.1rem;
                        }
                    }
                }
                .noData {
                    text-align: center;
                    font-size: 0.27rem;
                    color: #999999;
                    img {
                        width: 3.46rem;
                        margin: auto;
                        margin-top: 1rem;
                        height: 2.15rem;
                        margin-bottom: 0.1rem;

                    }
                }
            }
            .codeBox {
                padding: 0.3rem 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 0.1rem;
                .left {
                    margin-right: 0.2rem;
                    display: flex;
                    align-items: center;
                    .name {
                        font-size: 0.28rem;
                        color: #666666;
                        margin-right: 0.2rem;
                    }
                    .van-field {
                        width: 4.42rem;
                        background: #F5F7FA;
                        padding: 0.1rem 0.2rem;
                        box-sizing: border-box;
                        height: 0.64rem;
                    }
                }
                .right {
                    .van-button {
                        width: 1.2rem;
                        height: 0.64rem;
                        border: 0.02rem solid #409EFF;
                        border-radius: 0.32rem;
                        color: #409EFF;
                    }
                }
            }
            .affirmBtn {
                margin-top: 0.15rem;
                .van-button {
                    width: 100%;
                    height: 0.76rem;
                    background: #409EFF;
                    border-radius: 0.38rem;
                    color: #fff;
                    font-size: 0.3rem;
                }
            }
        }
    }
</style>